export default {
  menu: {
    clientMyAccount: "Mijn account",
    clientAccount: "Bedrijfsgegevens",
    clientSettings: "Systeem standaarden",
    imapSync: "E-mail synchronisatie",
  },

  defaultData: {
    input: {
      defaultCountry: "Systeem land",
      defaultCurrency: "Systeem valuta",
      language: {
        label: "Systeem taal",
        text: "Bepaald in welke taal automatische processen verlopen, \n zoals het genereren van een PDF factuur"
      },
    },
    error: {
      country: "Selecteer een standaard land",
      currency: "Selecteer een standaard valuta",
    },
    success: {
      patch: "Gegevens opgeslagen",
    },
    buttons: {
      save: "Opslaan",
    },
  },
}
